<template>
	<div class="footer bg-pink3 color-text2 layout-column">
		<div class="top layout-row">
			<div class="scroll-top color-pink1 layout-column layout-hv-center pointer" @click="scrollTop()">
				<font-awesome-icon class="fa-2x" icon="arrow-circle-up" />
				<div class="label">Top</div>
			</div>
			<div class="dfc-info">
				<img src="../../assets/logo-merrymama_x_dfc.jpg" width="200">
				<div class="info-item">活動相關諮詢：04-2371-6701</div>
				<div class="info-item">教學相關諮詢：02-2368-1310</div>
				<div class="info-item"><a href="http://www.merrymama.org.tw" target="_blank">小學生公益行動 DFC 挑戰</a></div>
				<!-- <div class="info-item"><a href="https://tycaa.dfctaiwan.org" target="_blank">DFC 臺灣</a></div> -->
				<!-- <div class="social-box">
					<a href="https://www.facebook.com/DesignForChangeTaiwan/?fref=ts" target="_blank"><img src="../../assets/media_fb.svg" alt=""></a>
					<a href="https://www.youtube.com/channel/UC93smbVyfDwtBj0AQW5M-XA" target="_blank"><img src="../../assets/media_youtube.svg" alt=""></a>
					<a href="https://www.flickr.com/photos/dfctaiwan" target="_blank"><img src="../../assets/media_flickr.svg" alt=""></a>
				</div> -->
			</div>
			<!-- <div class="navigation">
				<div class="nav-item">
					<a href="https://medium.com/design-for-change-taiwan" target="_blank">DFC 臺灣專欄</a>
				</div>
				<div class="nav-item">
					<a href="https://form.jotform.com/52560836639969" target="_blank">線上商店</a>
				</div>
				<div class="nav-item">
					<a href="https://tycaa.dfctaiwan.org/copyright" target="_blank">DFC 臺灣聲明</a>
				</div>
				<div class="nav-item pointer" @click="dialogVisible = true">
					<span>會員服務條款</span>
				</div>
				<div class="nav-item">
					<a href="https://tycaa.dfctaiwan.org/about" target="_blank">贊助合作夥伴</a>
				</div>
			</div> -->
			<!-- <div class="subscribe-news layout-column">
				<div class="title">訂閱電子報</div>
				<div class="normal-button subscribe-button" @click="subscribe()">訂閱</div>
			</div> -->
		</div>
		<!-- <div class="col" gutter="25">
			<div class="line"></div>
			<div class="col" gutter="40">
				<div class="col" gutter="20">
					<div class="title col" align-x="center">
						<div class="title-ch color-text2">DFC Taiwan 為全球 DFC 組織中的一員</div>
						<div class="title-en color-text3">DFC Taiwan Is Part of The Global DFC Community</div>
					</div>
					<div class="row" align-x="center" align-y="center" gutter="25">
						<img src="../../assets/logo.svg" alt="" width="82" />
						<img src="../../assets/sponsor3.png" alt="" width="127" />
					</div>
				</div>
				<div class="col" gutter="20">
					<div class="title col" align-x="center">
						<div class="title-ch color-text2">DFC 全球知識協力與合作夥伴</div>
						<div class="title-en color-text3">DFC Global Knowledge Partners & Collaborators</div>
					</div>
					<div class="row" align-x="center" align-y="center" gutter="20">
						<img src="../../assets/sponsor4.png" alt="" width="109" />
						<img src="../../assets/sponsor5.png" alt="" width="69" />
						<img src="../../assets/sponsor6.png" alt="" width="140" />
					</div>
					<div class="row" align-x="center" align-y="center" gutter="20">
						<img src="../../assets/sponsor7.png" alt="" width="140" />
						<img src="../../assets/sponsor8.png" alt="" width="141" />
						<img src="../../assets/sponsor9.png" alt="" width="49" />
					</div>
				</div>
			</div>
		</div> -->
		<!-- <a class="line-icon" href="https://m.me/DesignForChangeTaiwan" target="_blank"><img src="../../assets/media_messanger.png" width="50"></a> -->
		<terms-dialog :visible.sync="dialogVisible"></terms-dialog>
	</div>
</template>

<script>
import validator from "@/libs/validator";
import TermsDialog from "@/components/register/TermsDialog.vue";

export default {
	data() {
		var validateEmail = (rule, value, callback) => {
			if (!validator.isEmail(value)) {
				callback(new Error("請輸入正確Email格式"));
			} else {
				callback();
			}
		};
		return {
			dialogVisible: false,
			subscribeNews: {
				email: ""
			},
			rules: {
				email: [{ validator: validateEmail, trigger: ["blur", "change"] }]
			}
		};
	},
	computed: {},
	methods: {
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
		subscribe() {
			let url = "https://form.jotform.me/40688655858474";
			let win = window.open(url, "_blank");
			win.focus();
			// this.resetForm("subscribeNews");
		},
		scrollTop() {
			this.$bus.$emit("scrollTop");
		}
	},
	created() { },
	mounted() { },
	components: {
		TermsDialog
	}
};
</script>

<style lang='scss' scoped>
.footer {
	margin-top: 50px;
	min-width: 1000px;
	padding: 47px 120px 70px 120px;

	.top {
		justify-content: space-between;
		margin-bottom: 60px;
		position: relative;

		.scroll-top {
			opacity: 0.35;
			position: absolute;
			right: -66px;

			.label {
				font-size: 14px;
			}
		}
	}

	.title {
		font-weight: 500;
		margin-bottom: 15px;

		.title-ch {
			font-size: 16px;
			margin-bottom: 8px;
		}

		.title-en {
			font-size: 12px;
		}
	}

	.dfc-info {
		.info-item {
			line-height: 1.5;
			font-size: 14px;
		}
	}

	.social-box {
		margin-top: 20px;

		a {
			margin-right: 10px;
		}
	}

	.navigation {
		.nav-item {
			margin-bottom: 13px;
			font-size: 14px;

			a {
				color: #606266;
				text-decoration: none;
			}
		}

		.nav-item:hover {
			a {
				color: #ee6a8d;
			}
		}
	}

	.hide {
		display: none;
	}

	.subscribe-news {
		align-items: flex-end;

		.subscribe-button {
			width: 110px;
			height: 40px;
		}

		.email {
			width: 250px;
		}
	}

	.line {
		width: 100%;
		height: 1px;
		background-color: #c0c4cc;
	}

	.line-icon {
		position: fixed;
		bottom: 20px;
		right: 20px;

		img {
			width: 45px;
			height: 45px;
		}
	}
}
</style>